import type { SkipInputAction } from "../types/actions";
import type { StoneFlickingCoreState } from "../types/game-state";

export function applySkipInput(
  state: StoneFlickingCoreState,
  action: SkipInputAction,
): StoneFlickingCoreState {
  const newPendingInputs = new Map(state.pendingInputs);
  newPendingInputs.set(action.participantId, null);

  return {
    ...state,
    pendingInputs: newPendingInputs,
    submittedParticipants: [
      ...state.submittedParticipants,
      action.participantId,
    ],
  };
}
